<template>
    <div class="appointment-clone-modal">
        <b-modal :id="modalId"
                 @hidden="clearSelected"
                 size="lg">
            <template v-slot:modal-header>
                <h5>{{ $i18n.gt('HEADER_APPOINTMENT_CLONE') }}</h5>
            </template>

            <b-row class="clone-row">
                <div class="col">
                    <h4>{{ $i18n.gt('FIELD_APPOINTMENT_CLONE_FROM') }}</h4>
                    <b-calendar v-model="selectedDate"
                                :hide-header="true"/>
                </div>

                <div class="col clone-to">
                    <h4>{{ $i18n.gt('FIELD_APPOINTMENT_CLONE_TO') }}</h4>
                    <b-form-checkbox-group :options="weekDays"
                                           v-model="selectedWeekDays"
                                           buttons/>
                    <div class="week-count">
                        <div>{{ $i18n.gt('FIELD_APPOINTMENT_CLONE_FOR') }}</div>
                        <b-form-input type="number" step="1" max="78" min="1" v-model="weekCount"/>
                        <div>{{ $i18n.gt('FIELD_APPOINTMENT_CLONE_WEEKS') }}</div>
                    </div>
                </div>
            </b-row>

            <template v-slot:modal-footer>
                <b-btn @click="hideModal">{{ $i18n.gt('LABEL_CANCEL') }}</b-btn>
                <b-btn @click="validateClone">{{ $i18n.gt('LABEL_APPOINTMENT_CLONE') }}</b-btn>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'AppointmentCloneModal',
    props: {
        inputDate: String,
        reloadCalendar: Function,
        reloadSelected: Function,
    },
    data () {
        return {
            selectedWeekDays: [],
            weekDays: [
                { text: 'S', value: 0 },
                { text: 'M', value: 1 },
                { text: 'T', value: 2 },
                { text: 'W', value: 3 },
                { text: 'T', value: 4 },
                { text: 'F', value: 5 },
                { text: 'S', value: 6 },
            ],
            weekCount: null,
            selectedDate: this.inputDate ? this.inputDate : null
        }
    },
    computed: {
        modalId() {
            return `appointmentCloneModal`
        }
    },
    methods: {
        showModal() {
            this.$bvModal.show(this.modalId)
        },
        hideModal() {
            this.$bvModal.hide(this.modalId)
        },
        clearSelected() {
            this.selectedDate = null
            this.selectedWeekDays = [];
            this.weekCount = null
        },
        validateClone() {
            if (this.selectedDate === null
                || this.selectedWeekDays.length < 1
                || this.weekCount === null
                || this.weekCount < 1
                || this.weekCount > 78) {
                this.$toasted.error('Please fill out all fields to clone appointment times', {duration: 5000})
            } else this.clone()
        },
        async clone() {
            this.$bvModal.hide(this.modalId)
            await this.$api.cloneAppointments(this.$store.state.currentUser.id, this.selectedDate, this.selectedWeekDays, this.weekCount)
            this.reloadCalendar()
            this.reloadSelected()
        }
    }
})
</script>

<style lang="scss">
    #appointmentCloneModal {
        .clone-row {
            @media (max-width: 576px) {
                display: block;
                .clone-to {
                    padding-top: 1em;
                }
                .clone-to > div {
                    padding: 1em;
                }
            }
        }
        .b-calendar .b-calendar-nav .btn {
            color: var(--gray);
            &:hover {
                color: var(--white);
            }
        }
        .btn-outline-primary {
            color: var(--blue);
            &:hover {
                color: var(--white);
            }
        }
        .col {
            justify-content: center;
            display: grid;
            text-align: center;
        }
        .btn-group .btn {
            height: 3em;
            padding: 1em;
        }
        .week-count {
            display: inline;
            div, input {
                width: 5em;
                display: inline-block;
            }
        }
    }
</style>
